var _rect, _path, _rect2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIrLiftsMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#001F97"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3332 13.3333L11.9998 14.6667L13.6665 13.3333M10.3332 10.6667L11.9998 9.33333L13.6665 10.6667M6.6665 16.6667L6.6665 7.33333C6.6665 6.59695 7.26346 6 7.99984 6L15.9998 6C16.7362 6 17.3332 6.59695 17.3332 7.33333L17.3332 16.6667C17.3332 17.403 16.7362 18 15.9998 18L7.99984 18C7.26346 18 6.6665 17.403 6.6665 16.6667Z",
    stroke: "white",
    strokeWidth: 1.32727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.2612,
    y: 4.66284,
    width: 5.20308,
    height: 5.09349,
    rx: 0.995455,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8123 5.62218V8.66284H15.1694V5.62218H15.8123ZM16.3412 8.66284V5.62218H17.5408C17.7705 5.62218 17.9664 5.66325 18.1288 5.74541C18.2921 5.82657 18.4163 5.94188 18.5014 6.09134C18.5875 6.23981 18.6306 6.41451 18.6306 6.61544C18.6306 6.81736 18.5871 6.99107 18.4999 7.13657C18.4128 7.28108 18.2866 7.39194 18.1214 7.46914C17.957 7.54635 17.7581 7.58495 17.5245 7.58495H16.7213V7.06827H17.4206C17.5433 7.06827 17.6453 7.05145 17.7264 7.0178C17.8076 6.98414 17.868 6.93366 17.9076 6.86636C17.9481 6.79905 17.9684 6.71541 17.9684 6.61544C17.9684 6.51448 17.9481 6.42936 17.9076 6.36007C17.868 6.29079 17.8071 6.23833 17.7249 6.2027C17.6438 6.16607 17.5413 6.14776 17.4176 6.14776H16.9841V8.66284H16.3412ZM17.9833 7.2791L18.739 8.66284H18.0293L17.2899 7.2791H17.9833Z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIrLiftsMarker);
export default __webpack_public_path__ + "static/media/IrLiftsMarker.47ec56349622eeb6d74e35f2a29b6551.svg";
export { ForwardRef as ReactComponent };